import { Component, OnInit, OnDestroy, Input, ɵConsole } from '@angular/core';
import { Owner, Country, Provincia, Comune, Company, company, Project, ProjectStatus, Tender, ProjectData, JsonData, getProjectStatusOptions, User, UserType } from 'toolbandi-ui-lib';
import { Search, ListItem, CrudService, MessageService, SharedDataService, ListService } from 'elbuild-ui-lib-core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-owner-edit',
	templateUrl: './project-edit.component.html',
	styleUrls: ['./project-edit.component.scss']
})
export class ProjectEditComponent implements OnInit, OnDestroy {


	loading: boolean = false;
	project: Project;

	tab: string;

	editable: boolean = true;

	@Input()
	companyid: number;

	search: any;
	selected: any;


	tenderClass: ClassType<Tender> = Tender;
	errormessage: any;
	projectStatus = ProjectStatus;

	statusoptions = getProjectStatusOptions();
	isCompany: boolean;
	warning: any;



	constructor(
		private projectService: CrudService<Project>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private companyService: CrudService<Company>,
		private activeModal: NgbActiveModal
	) {
		this.loading = false;
		this.search = {
			company: new Search('company'),
			tender: new Search('tender')
		};
		this.selected = {
			company: undefined,
			tender: undefined
		};
		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {

				const user: User = data as User;
				this.isCompany = user.utype === UserType.company;
			}
		});
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.project = new Project();
				if (this.companyid) {
					this.project.companyid = this.companyid;

					this.companyService.getEntity(Company, 'company', this.companyid).subscribe(data => {
						this.selected.company = data;
					});
				}
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.projectService.getEntity(Project, 'project', id).subscribe(project => {
			this.project = project;
			this.selected.company = project.company;
			this.selected.tender = project.tender;
			this.loading = false;

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.owner'));
			this.project = undefined;
			this.loading = false;
		});

	}


	dismiss() {
		this.activeModal.dismiss();
	}

	submit() {

		this.warning = undefined;
		this.errormessage = undefined;
		this.project.companyid = this.selected.company.id;
		this.project.tenderid = this.selected.tender.id;
		this.loading = true;

		if (!this.project.id) {

			this.projectService.createEntity(Project, 'project', this.project).subscribe((response: Project) => {
				this.project = response;
				const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
				this.activeModal.close(this.project);
				this.errormessage = undefined;
				this.loading = false;

			}, ({ error }) => {
				if (error.msg) {
					this.errormessage = error.msg;
				} else {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
					this.errormessage = undefined;
					this.loading = false;
				}

			});
		} else {
			if (this.project.reporting) {
				this.warning = this.translateService.instant('labels.project-save-long')
			}
			this.projectService.saveEntity(Project, 'project', this.project).subscribe((response: Project) => {
				this.project = response;
				const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
				this.loading = false;
				this.warning = undefined;
				this.activeModal.close(this.project);
				this.errormessage = undefined;


			}, ({ error }) => {

				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
				this.errormessage = error.msg
				this.warning = undefined;
				this.loading = false;
			});
		}


	}


}

